import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Navbar from './components/common/Navbar';
import Footer from './components/common/Footer';
import ProtectedRoute from './components/common/ProtectedRoute';
import ChatLauncher from './components/chat/ChatLauncher';
import { FilterProvider } from './context/FilterContext';
import { STAFF_ROLES } from './utils/constants';

import HomePage from './components/home/HomePage';
import LoginPage from './components/auth/LoginPage';
import RegisterPage from './components/auth/RegisterPage';
import ServiceRequestPage from './pages/ServiceRequestPage';
import JobsPage from './pages/JobsPage';

import BrowseTechnicians from './components/technician/TechnicianList';
import TechnicianDetail from './components/technician/TechnicianDetail';

import ClientDashboard from './components/client/ClientDashboard';
import ClientBookings from './components/client/MyBookings';
import BookingForm from './components/client/BookingForm';

import TechnicianDashboard from './components/technician/TechnicianDashboard';
import TechnicianProfile from './components/technician/TechnicianProfile';
import TechnicianJobs from './components/technician/MyBookings';
import TechnicianReviews from './components/technician/Reviews';

import BookingApproval from './components/review/BookingApproval';
import TechnicianApproval from './components/review/TechnicianApproval';
import ServiceRequestQueue from './components/review/ServiceRequestQueue';
import ChatInbox from './components/review/ChatInbox';

import AdminDashboard from './components/admin/AdminDashboard';
import UserManagement from './components/admin/UserManagement';
import ServiceManagement from './components/admin/ServiceManagement';
import SystemSettings from './components/admin/SystemSettings';

export default function App() {
  const location = useLocation();
  const hideChrome = location.pathname === '/login';

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/service-request" element={<ServiceRequestPage />} />
        <Route path="/offres-emploi" element={<JobsPage />} />

        <Route
          path="/technicians"
          element={
            <FilterProvider>
              <BrowseTechnicians />
            </FilterProvider>
          }
        />
        <Route path="/technicians/:id" element={<TechnicianDetail />} />

        {/* Client */}
        <Route element={<ProtectedRoute allowedRoles={['CLIENT']} />}>
          <Route path="/client" element={<ClientDashboard />} />
          <Route path="/client/bookings" element={<ClientBookings />} />
          <Route path="/client/book/:technicianId" element={<BookingForm />} />
        </Route>

        {/* Technician */}
        <Route element={<ProtectedRoute allowedRoles={['TECHNICIAN']} />}>
          <Route path="/technician" element={<TechnicianDashboard />} />
          <Route path="/technician/profile" element={<TechnicianProfile />} />
          <Route path="/technician/bookings" element={<TechnicianJobs />} />
          <Route path="/technician/reviews" element={<TechnicianReviews />} />
        </Route>

        {/* Review queue — ADMIN + APPROVER */}
        <Route element={<ProtectedRoute allowedRoles={STAFF_ROLES} />}>
          <Route path="/review/bookings" element={<BookingApproval />} />
          <Route path="/review/technicians" element={<TechnicianApproval />} />
          <Route path="/review/service-requests" element={<ServiceRequestQueue />} />
          <Route path="/review/chat" element={<ChatInbox />} />
        </Route>

        {/* Admin only */}
        <Route element={<ProtectedRoute allowedRoles={['ADMIN']} />}>
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/users" element={<UserManagement />} />
          <Route path="/admin/services" element={<ServiceManagement />} />
          <Route path="/admin/settings" element={<SystemSettings />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {!hideChrome && <Footer />}
      {!hideChrome && <ChatLauncher />}
    </>
  );
}
